import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileContext } from "../../../context/ContextProfile";
import ProgressiveImg from "./ProgressiveImg";

function youtube_parser(url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
}

function removeFileExtension(filename) {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) return filename;
  return filename.substring(0, lastDotIndex);
}

function SliderCard({ image, onClick }) {
  const isVideo = image.isVideo == 1;
  const src = isVideo
    ? `https://img.youtube.com/vi/${youtube_parser(image.path[0])}/0.jpg`
    : `https://aldealista.com/p/${image.path[0]}`;

  return (
    <div className="slider-card" onClick={onClick}>
      <ProgressiveImg src={src} alt={image.title} />
      <div className="ig-caption">
        <span>{image.title}</span>
        {isVideo ? (
          <i className="fa fa-play-circle" aria-hidden="true"></i>
        ) : (
          image.path.length > 1 && (
            <i className="fa fa-clone" aria-hidden="true"></i>
          )
        )}
      </div>
    </div>
  );
}

function SliderRow({ heading, items, onImageClick }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="slider-section">
      <p className="slider-heading">{heading}</p>
      <div className="slider-row">
        {items.map((image, index) => (
          <SliderCard
            key={image.id || index}
            image={image}
            onClick={() => onImageClick(image)}
          />
        ))}
      </div>
    </div>
  );
}

function SliderTop({ mostVisited, recommendations }) {
  const { modifySelectedImage } = useContext(ProfileContext);
  const navigate = useNavigate();

  const onImageClick = (image) => {
    const filename =
      image.isVideo == 1
        ? youtube_parser(image.path[0])
        : removeFileExtension(image.path[0]);
    modifySelectedImage(image);
    navigate(`/images/${filename}`);
  };

  return (
    <>
      <SliderRow
        heading="Lo más visitado"
        items={mostVisited}
        onImageClick={onImageClick}
      />
      <SliderRow
        heading="Nuestras recomendaciones"
        items={recommendations}
        onImageClick={onImageClick}
      />
    </>
  );
}

export default SliderTop;
